import React from 'react';
// import * as Sentry from "@sentry/react";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';

// Sentry.init({
//   environment: process.env.NODE_ENV,
//   dsn: "https://855b043557dee277c13df49094b78b99@o4506423875731456.ingest.sentry.io/4506672408690688",
//   whitelistUrls: [/mijnetickets\.shop/],
//   ignoreErrors: [
//     'Failed to fetch',
//     'NetworkError when attempting to fetch resource.',
//     'Load failed',
//     // Random plugins/extensions
//     "top.GLOBALS",
//     // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
//     "originalCreateNotification",
//     "canvas.contentDocument",
//     "MyApp_RemoveAllHighlights",
//     "http://tt.epicplay.com",
//     "Can't find variable: ZiteReader",
//     "jigsaw is not defined",
//     "ComboSearch is not defined",
//     "http://loading.retry.widdit.com/",
//     "atomicFindClose",
//     // Facebook borked
//     "fb_xd_fragment",
//     // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
//     // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
//     "bmi_SafeAddOnload",
//     "EBCallBackMessageReceived",
//     // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
//     "conduitPage",
//     // Generic error code from errors outside the security sandbox
//     // You can delete this if using raven.js > 1.0, which ignores these automatically.
//     "Script error.",
//     // Avast extension error
//     "_avast_submit",
//     'zoom requires valid numbers',
//       "Cannot read properties of null (reading 'postMessage')",
//       'ResizeObserver loop completed with undelivered notifications.',
//       'Unexpected end of input',
//       "Unexpected token 'else'"
//   ],
//   denyUrls: [
//     // Google Adsense
//     /pagead\/js/i,
//     // Facebook flakiness
//     /graph\.facebook\.com/i,
//     // Facebook blocked
//     /connect\.facebook\.net\/en_US\/all\.js/i,
//     // Woopra flakiness
//     /eatdifferent\.com\.woopra-ns\.com/i,
//     /static\.woopra\.com\/js\/woopra\.js/i,
//     // Chrome extensions
//     /extensions\//i,
//     /^chrome:\/\//i,
//     /^chrome-extension:\/\//i,
//     // Other plugins
//     /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
//     /webappstoolbarba\.texthelp\.com\//i,
//     /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
//   ],
//   integrations: [
//     new Sentry.BrowserTracing({
//       // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//       tracePropagationTargets: ["localhost", /^https:\/\/api\.mijnetickets\.nl/],
//     }),
//     new Sentry.Replay({
//       maskAllText: false,
//       blockAllMedia: false,
//     }),
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 0.2, //  Capture 100% of the transactions
//   // Session Replay
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<React.StrictMode>
  <App />
</React.StrictMode>);


reportWebVitals();
